module.exports = __webpack_public_path__ + "img/google-login.7cca17ef.svg";